// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__p1CZ8","sliderContainer":"Slider_sliderContainer__nR97J","helper":"Slider_helper__TtsdO"};